import { AuthenticateApiRequest } from '../../../../types/requests/authentication/authenticate.request';
import { PasswordResetApiRequest } from '../../../../types/requests/authentication/password-reset.request';
import { RecoverPasswordApiRequest } from '../../../../types/requests/authentication/recover-password.request';
import { ValidatePasswordResetTokenApiRequest } from '../../../../types/requests/authentication/validate-password-reset-token.request';
import { authenticate, passwordReset, recoverPassword, validatePasswordResetToken } from '../../api/authentication.api';
import { useAxiosMutation, useAxiosQuery } from './use-axios.hook';

export const useAuthenticate = () => {
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: AuthenticateApiRequest) => (await authenticate(params)).data,
  });
  // const [, setAccessToken] = useLocalStorage('accessToken');
  if (data) {
    // setAccessToken(JSON.stringify(data));
    window.localStorage.setItem('accessToken', JSON.stringify(data));
  }
  return [request, { ...result, accessToken: data }] as const;
};

export const useRecoverPassword = () => {
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: RecoverPasswordApiRequest) => (await recoverPassword(params)).data,
  });
  return [request, result] as const;
};

export const useValidatePasswordResetToken = (params: ValidatePasswordResetTokenApiRequest) => {
  const { data, ...result } = useAxiosQuery({
    queryKey: ['password-reset'],
    queryFn: async () => (await validatePasswordResetToken(params)).data,
    enabled: Boolean(params.token),
  });
  return { ...result } as const;
};

export const usePasswordReset = () => {
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: PasswordResetApiRequest) => (await passwordReset(params)).data,
  });
  return [request, result] as const;
};
